import React, { Component } from 'react'
import Details from './details'
import { add, min, getItem } from "./functions";
import Push from 'push.js';
import './Item.css'

export default class Item extends Component {

    state = {
        active: false,
        price: {
            buying: 0,
            selling: 0
        }
    }

    componentDidMount() {
        this.props.tracker && this.setupInitialPrice().then(() =>
            this.notifier = setInterval(this.checkPrice, 1000 * 60)
        )
    }

    toggle = () => this.setState({ active: !this.state.active })

    componentWillUnmount() { this.props.tracker && clearInterval(this.notifier) }

    setupInitialPrice = () => getItem(this.props.id).then(e => { this.updatePrice(e.buying, e.selling) })

    getNotificationMessage = ({oldBuy,newBuy,oldSell,newSell}) =>{
        const buyDiff = this.diff(oldBuy,newBuy);
        const sellDiff = this.diff(oldSell,newSell) 
        return `[B](${buyDiff}): ${oldBuy} => ${newBuy}\n[S](${sellDiff}): ${oldSell} => ${newSell}`
    }

    // o = old
    // n = new
    diff = (o, n) => n - o === 0 ? 0 : n - o > 0 ? `+${n - o}` : n - o
    updatePrice = (buying, selling) => this.setState({ price: { buying, selling } })
    checkPrice = () => {
        getItem(this.props.id).then(e => {
            const { buying, selling } = this.state.price
            if ((e.buying && buying && buying !== e.buying) || (e.selling && selling && selling !== e.selling)) {
                const pushSettings = {
                    icon: `http://cdn.rsbuddy.com/items/${this.props.id}.png`,
                    body: this.getNotificationMessage({
                        oldBuy:buying,
                        newBuy:e.buying,
                        oldSell:selling,
                        newSell:e.selling
                    })
                }
                Push.create(this.props.name, pushSettings)
                this.updatePrice(e.buying, e.selling);
            }
        })
    }
    shouldComponentUpdate(prevProps, prevState) { return (this.props.type !== prevProps.type || this.state.active !== prevState.active) }

    render() {
        const {name,id,type} = this.props
        return (
            <div className="Item">
                <div className="upperline">
                    <img src={`http://cdn.rsbuddy.com/items/${id}.png`}
                    alt={name}
                    onClick={() => window.open(`https://rsbuddy.com/exchange?id=${id}`)}/>
                    <div className="name">
                        <div className={`fa fa-line-chart fa-2x ${type}`} onClick={this.toggle} />
                        {name}
                    </div>
                    <div
                    className={`fa fa-${type === 'add' ? "plus" : "minus"} fa-2x ${type}`}
                    onClick={
                        ()=>
                        type === "add" 
                        ? add(this.props) 
                        : min(this.props)
                    } />
                </div>
                { this.state.active && <Details {...this.props} {...this.state}/> }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/item/index.js